// Hanterar bakåtknapp-navigering i appen.
// Varje overlay som öppnas registrerar en close-funktion.
// Bakåtknappen stänger senast öppnade overlay istället för att lämna appen.

const stack = [];
let suppress = false;

// Lägg alltid en guard-entry direkt så appen inte kan stängas via bakåtknappen.
history.pushState({ managed: true }, '');

window.addEventListener('popstate', () => {
  if (suppress) {
    suppress = false;
    return;
  }
  if (stack.length > 0) {
    stack.pop()();
  } else {
    // Stacken är tom – lägg tillbaka guard-entry så appen stannar kvar.
    history.pushState({ managed: true }, '');
  }
});

// Registrera en overlay – anropas när overlay öppnas.
export function pushBack(closeFn) {
  history.pushState({ managed: true }, '');
  stack.push(closeFn);
}

// Avregistrera en overlay – anropas när overlay stängs manuellt (inte via bakåtknapp).
export function popBack() {
  if (stack.length > 0) {
    stack.pop();
    suppress = true;
    history.back(); // Synka webbläsarhistoriken utan att trigga handler
  }
}

// Byt ut toppen av stacken mot en ny close-funktion utan att röra browser-historiken.
// Används när en overlay ersätts av en annan direkt (t.ex. members → member profile),
// så att vi undviker kapplöpning mellan history.back() och history.pushState().
export function swapBack(closeFn) {
  if (stack.length > 0) {
    stack.pop();
  }
  stack.push(closeFn);
}
